import '@doss/guest-frame/boot-splash.css'
import {
  BOOT_LAP_MULTIPLIER,
  BOOT_ORBIT_FALLBACK_MS,
  bootSpinnerHtml,
} from '@doss/guest-frame/boot-splash-markup'
import { useId } from 'react'
import { useTypedTranslation } from '~/common/hooks/useTypedTranslation'

// Sets the phase of the boot animation so handoff from Host to Guest is seamless. Apply pre-paint to keep render pure.
const setBootPhase = (el: HTMLDivElement | null): void => {
  if (el === null) {
    return
  }
  const now = Date.now()
  el.style.setProperty('--doss-boot-sync-after', `${-(now % BOOT_ORBIT_FALLBACK_MS)}ms`)
  el.style.setProperty(
    '--doss-boot-sync-lap',
    `${-(now % (BOOT_ORBIT_FALLBACK_MS * BOOT_LAP_MULTIPLIER))}ms`,
  )
}

/**
 * Host-side loader as the guest's content is fetched. Imports the same loader from the guest-frame
 * so that when the guest begins its own loading, it appears as a single process.
 * The animation on each side is synced by the animation start point being based on wall clock.
 */
export const DynamicAppBootup = () => {
  const { t } = useTypedTranslation()
  return (
    <div
      aria-busy="true"
      aria-label={t('common.actions.loading')}
      className="relative size-full"
      role="status"
    >
      <div
        dangerouslySetInnerHTML={{ __html: bootSpinnerHtml(useId()) }}
        ref={setBootPhase}
        aria-hidden
        className="doss-boot-splash"
      />
    </div>
  )
}
